import styled from "styled-components";
import { FormButton, FormButtonCancel } from "../../../components/Form";
import {
  AuthFormInput,
  AuthFormInputPassword,
  AuthFormInputSpan,
} from "../../auth/styles";

export const Modal = styled.div`
  position: fixed;
  z-index: 10;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  overflow-y: auto;
  background-color: rgba(0, 0, 0, 0.5);
`;
export const ModalBg = styled.div`
  z-index: 9;
  width: 100%;
  height: 500%;
  top: 0;
  left: 0;
  position: fixed;
`;
export const ModalContent = styled.div`
  position: relative;
  z-index: 12;
  width: 847px;
  background: #f5f5f5;
  box-shadow: 0px 0px 36px rgba(0, 0, 0, 0.25);
  border-radius: 64px;
  padding: 52px 59px 55px 70px;
  margin: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media screen and (max-width: 1024px) {
    & {
      padding: 24px;
      width: calc(100% - 24px);
      //max-height: 100%;
      //overflow-y: auto;
      border-radius: 20px;
      margin-top: 24px;
    }
  }
`;

export const Title = styled.div`
  width: 100%;
  font-weight: 700;
  font-size: 24px;
  line-height: 34px;
  text-align: center;
  margin-left: auto;
  display: inline-block;
  margin-right: auto;
  
  margin-bottom: 45px;
`;

export const BTCValue = styled.div`
  font-weight: 700;
  font-size: 16px;
  color: #F12E11;
  margin-right: 12px;
`;
export const LocalValue = styled.div`
  font-weight: 700;
  font-size: 16px;
  color: #F12E11;
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 12px;
  @media screen and (max-width: 1024px) {
    & {
      display: block;
    }
  }
`;
export const Row = styled.div`
  @media screen and (max-width: 1024px) {
    & {
    }
  }
`;
export const Cell = styled.div`
  flex: 1;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 20px;
  @media screen and (max-width: 1024px) {
    & {
      display: block;
    }
  }
`;
export const CellTitle = styled.div`
  width: 240px;
  font-weight: 700;
  font-size: 16px;
  color: #818181;

  @media screen and (max-width: 1024px) {
    & {
      font-size: 14px;
      margin-bottom: 12px;
      width: unset;
    }
  }
`;
export const CellValue = styled.div`
  font-weight: 600;
  font-size: 16px;
  color: #000000;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 26px;
  flex: 1;

  & .address {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
    overflow-wrap: break-word;
    width: 100%;
  }

  & a {
    font-weight: 400;
    font-size: 16px;
    color: #548feb !important;
    display: block;
    flex: 1;
  }

  @media screen and (max-width: 1024px) {
    & {
      font-size: 14px;
      height: auto;
    }

    & .ant-form-item {
      margin-top: 0 !important;
      margin-bottom: 24px !important;
    }

    & .send-code {
      top: 14px !important;
    }
  }

  @media screen and (max-width: 500px) {
    max-width: 400px;
    text-overflow: ellipsis;
    overflow: hidden;
  }
`;

export const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 50px;
  margin-top: 50px;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  @media screen and (max-width: 1024px) {
    border: none;
    margin-top: 0;
    padding-top: 24px;
  }
`;
export const FormButtonCancel2 = styled(FormButtonCancel)`
  background: #000000 !important;
  border-radius: 15px;
  box-shadow: none;
  min-width: 160px;

  &:hover,
  &:focus {
    opacity: 0.9;
  }

  span {
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
    color: #ffffff;
  }

  @media screen and (max-width: 1024px) {
    & {
      width: 130px;
      height: 43px;
      font-weight: 700;
      font-size: 14px;
      line-height: 17px;
      min-width: auto;
    }
  }
`;

export const FormButtonCancel3 = styled(FormButtonCancel)`
  background: #fff !important;
  border: 1px solid #000000;
  border-radius: 15px;
  box-shadow: none;
  min-width: 160px;

  &:hover,
  &:focus {
    border: 1px solid #000000;
  }
  span {
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
    color: #000000;
  }

  @media screen and (max-width: 1024px) {
    & {
      width: 137px;
      height: 43px;
      font-weight: 700;
      font-size: 14px;
      line-height: 17px;
      min-width: auto;
    }
  }
`;
export const FormButton2 = styled(FormButton)`
  border-radius: 15px;
  min-width: 160px;

  @media screen and (max-width: 1024px) {
    & {
      width: 130px;
      height: 43px;
      font-weight: 700;
      font-size: 14px;
      line-height: 17px;
      min-width: auto;
    }
  }
`;
export const AuthFormInputPassword2 = styled(AuthFormInputPassword)`
  background: #ffffff;
  border-radius: 10px;
  box-shadow: none;
  padding-left: 22px;

  input {
    font-weight: 400;
    font-size: 16px;
    line-height: 25px;
  }

  @media screen and (max-width: 1024px) {
    & {
      height: 52px;
    }
  }
`;
export const AuthFormInput2 = styled(AuthFormInput)`
  & {
    font-weight: 400;
    font-size: 16px;
    line-height: 25px;
    padding-left: 22px;
  }

  @media screen and (max-width: 1024px) {
    & {
      height: 52px;
    }
  }
`;
export const AuthFormInputSpan2 = styled.span`
  font-weight: 500;
  font-size: 14px;
  line-height: 25px;
  cursor: pointer;
`;

export const ModalCloseX = styled.div`
  cursor: pointer;
  display: inline-block;
  position: fixed;
  z-index: 9;
  right: 32px;
  top: 32px;

  @media screen and (max-width: 1024px) {
    display: inline-block;
    position: absolute;
    z-index: 9;
    right: 12px;
    top: -12px;
  }
`;

export const CloseX1 = (props) => (
  <svg
    {...props}
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="16" cy="16" r="16" fill="white" />
    <path
      d="M23.1615 8.55048L8.7373 22.9747"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.7373 8.55048L23.1615 22.9747"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const CloseX2 = (props) => (
  <svg
    {...props}
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M40.8809 6.44043L6.88086 40.4404"
      stroke="white"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.88086 6.44043L40.8809 40.4404"
      stroke="white"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
